/* eslint-disable quotes */
/* eslint-disable max-lines */
export default {
  new_feature_notification: {
    check_out_new_feature: 'Check out the new feature!'
  },
  change_request_modal: {
    title: 'Change Request Submitted',
    message: 'Your edition request has been submitted successfully. Please wait for admin approval before proceeding.',
    got_it: 'Got it'
  },
  blocked_app_modal: {
    title: 'Account Blocked',
    message: 'Your account has been blocked. To get more information, please contact the administrator.',
    contact_admin: 'Contact Administrator',
    additional_info:
      'If you believe this is an error or need immediate assistance, please contact our support team. We apologize for any inconvenience this may cause.'
  },
  captcha_page: {
    title: 'Please verify that you are human to continue.',
    error: 'Verification failed. Please try again.',
    expired: 'Verification expired. Please try again.',
    load_error: 'Unable to load verification. Please refresh the page.',
    verifying: 'Verifying...'
  },
  phone_confirmation_modal: {
    title: 'Confirm your phone number',
    description: 'Enter your phone number. We will send an SMS to it.',
    phone: 'Phone number',
    phone_placeholder: '+48 111 222 333',
    send_sms: 'Send SMS',
    sending: 'Sending...',
    sent: 'The SMS has been sent.',
    too_soon: 'Wait a minute before sending another SMS.',
    limit_reached: 'You can send at most 5 SMS messages per hour. Try again later.',
    phone_required: 'Phone number is required',
    error: 'Could not send the SMS. Please try again.',
    code: 'Code from the SMS',
    code_placeholder: '123456',
    confirm: 'Confirm',
    confirming: 'Confirming...',
    invalid_code: 'The code is incorrect.',
    code_required: 'Enter the code from the SMS.',
    confirm_error: 'Could not confirm the phone number. Please try again.'
  },
  demo_modal: {
    demo_expired: 'Demo expired',
    title: 'We will help you',
    title_highlight: 'activate your full access.',
    subtitle: 'Have questions about the platform? We are here to help.',
    badge: 'Full Dealer Access',
    full_access_title: 'Full Access',
    full_access_description: 'For dealers ready to start sourcing bikes and making profit.',
    price: '990€',
    price_period: '/ one-time payment',
    features: {
      live_listings: 'Full access to live, verified listings from private sellers',
      bid_buy: 'Full ability to bid or buy, with full control over transport',
      priority_support: 'Priority onboarding and dealer support',
      mobile_app: 'Full access to mobile app'
    },
    support_text:
      'If you have any questions about this step or the platform itself, email us at partner@estigroup.de — our team will respond quickly to help you get started.',
    form: {
      title: 'Complete your company details to unlock full buying access',
      description:
        'We need this information to prepare your dealer agreement and activate your ability to buy vehicles on the platform.',
      company_id: 'Company ID',
      company_id_placeholder: 'Your ID',
      company_name: 'Company Name',
      company_name_placeholder: 'Name of company',
      address: 'Address',
      address_placeholder: 'Street name',
      city: 'City',
      city_placeholder: 'Name of city',
      postal_code: 'Postal code',
      postal_code_placeholder: 'Postal code',
      phone_number: 'Phone Number',
      phone_number_placeholder: 'Your phone number',
      privacy_policy: 'By submitting my info I confirm that i have read and understood the Estimoto Privacy Policy',
      submit_button: 'Request full access',
      errors: {
        company_id_required: 'Company ID is required',
        company_name_required: 'Company name is required',
        address_required: 'Address is required',
        city_required: 'City is required',
        postal_code_required: 'Postal code is required',
        phone_number_required: 'Phone number is required',
        privacy_policy_required: 'You must accept the privacy policy'
      }
    }
  },
  test_access_banner: {
    demo_mode: 'Demo Mode',
    expires_on: 'Expires on',
    contact_support: 'Contact Support',
    upgrade_now: 'Upgrade Now'
  },
  pagination: {
    showing_items: '{{startItem}}-{{endItem}} of {{totalItems}} results'
  },
  only_buy_now_dec: 'Show only buy now offers',
  only_buy_now: 'Buy Now',
  just_sold: 'Sold Vehicles',
  in_realization_list_item: {
    contact_info: 'Contact',
    email: 'Email',
    phone: 'Phone',
    help: 'Help',
    arrange_transport: 'Arrange Transport',
    transport_arranged: 'Transport Arranged',
    transport_arranged_long: 'The vehicle has been handed over to transport',
    confirm_receipt: 'Confirm Pickup',
    vehicle_data: 'Specification',
    contract_pdf: 'Handover Confirmation',
    spedition: 'Arrange transport pickup',
    choose_spedition: 'Choose spedition',
    spedition_note: 'Message to transport',
    spedition_terms_1: 'By placing the order, you accept the terms and conditions of the selected spedition.',
    create_transport_button: 'Send Order',
    confirm_pick_up: 'The vehicle was successfully purchased and picked up.',
    confirm_button: 'Confirm Pickup',
    cancel: 'Cancel',
    accepted: 'Accepted',
    credit_data: 'Credit Details',
    price: 'Vehicle Price',
    provision: 'Commission',
    deregistering_person: 'Vehicle deregistration',
    deregistering_person_dealer: 'Buyer (dealer)',
    deregistering_person_seller: 'Seller',
    deregistering_person_later: 'To be decided',
    deregistering_person_already_deregistered: 'Already deregistered'
  },
  invoices_screen: {
    screen_title: 'Invoices'
  },
  bottom_menu: {
    sell: 'Sell',
    search: 'Search',
    want_to_buy: 'Buy',
    settings: 'Settings'
  },
  platform_terms: {
    title: 'Platform Terms',
    files: [
      {
        label: 'Allgemeine zusätzliche Geschäftsbedingungen (AGB-Z)',
        href: '/Allgemeine zusätzliche Geschäftsbedingungen (AGB-Z).pdf'
      },
      { label: 'AGB Estigroup (DE)', href: '/AGB-ESTIGROUP-DE.pdf' }
    ]
  },
  soon: 'Soon',
  buy_now_modal: {
    title: 'Buy Vehicle Now',
    by_clicking: 'by purchasing you accept our',
    buy_now: 'Terms',
    you_realize_sell: 'and',
    terms: 'Privacy Policy',
    buy_now_button: 'Confirm',
    realization: 'Contact Seller',
    you_offer_has_been_sent: 'Congratulations \n You can now \n contact the seller.',
    go_to_realization: 'Arrange a handover appointment within 48 hours or arrange transport for pickup.'
  },
  auction_contract_modal: {
    by_clicking: '',
    you_are_accepting: '',
    title: 'Make a fair and realistic offer.',
    term: 'Your offer is binding for <strong>14 days</strong>. \n By placing a bid you accept our <strong>Terms</strong>.',
    price: 'Price.\n',
    offer_time: 'Your offer',
    offer_time_span: 'is binding for 14 days.',
    resign: 'Cancel',
    place_offer: 'Place Bid',
    place_offer_title: '',
    go_to_bets: 'My Offers',
    your_offer_has_been_sent: 'The offer has been submitted.',
    go_to_bets_desc: 'Go to your purchases \n to track progress.',
    only_fail_offer_will_be_sent: `
    If your offer is too far from a realistic purchase price, \n we are not obligated to send it to the seller.
    You can see the current \n status of your offers \n in your purchases.`,
    we_will_notify: ''
  },
  single_offer: {
    check_price_on_mobile: 'Check Price',
    roadworthy: 'Roadworthy',
    not_roadworthy: 'Not Roadworthy',
    gross_vehicle_weight: 'Gross Vehicle Weight',
    length: 'Length',
    width: 'Width',
    engine_capacity: 'Engine Capacity',
    engine_power: 'Power',
    automatic_gearbox: 'Automatic Transmission',
    date_of_first_registration: 'First Registration',
    year_of_production: 'First Registration',
    added: 'Published',
    ago: '-',
    unread_messages: 'Message',
    screen_title: 'Vehicle Details',
    gallery: 'Images',
    your_highest: 'Your Offer',
    buy_now: 'Buy Now',
    minimal_price: 'Asking Price',
    place_an_offer: 'Place Bid',
    place_an_different_offer: 'Place Different Offer',
    buy_now_button: 'Buy Now',
    vehicle_description: 'Vehicle Details',
    first_registration: 'First Registration',
    total_mileage: 'Mileage',
    zip_code: 'ZIP Code',
    origin_country: 'Country of Origin',
    import_description_options: {
      germany: 'Germany',
      austria: 'Austria',
      italy: 'Italy',
      netherlands: 'Netherlands',
      usa: 'USA',
      great_britain: 'Great Britain',
      france: 'France',
      belgium: 'Belgium',
      not_known: 'Unknown',
      other: 'Other'
    },
    rental_description: 'Type of Use',
    rental_description_options: {
      demo: 'Demo Motorcycle',
      driving_course: 'Driving School Motorcycle',
      rental: 'Rental Motorcycle'
    },
    used_commercially: 'Used commercially',
    not_rental: 'No Commercial Use',
    previous_owners: 'Number of Previous Owners',
    number_of_previous_owners_options: {
      _0_: '0',
      _1_: '1',
      _2_: '2',
      _3_: '3',
      _4_: '4',
      more_than_4: 'More than 4',
      not_known: 'Unknown'
    },
    addiction_info: 'Additional Information',
    accident_free: 'Accident Free',
    with_accident: 'Accident Vehicle',
    not_wrecked: 'Never Dropped',
    wrecked: 'Dropped',
    original_lacquer: 'Original Paint',
    not_original_lacquer: 'Not Original Paint',
    without_defects: 'No Other Damage',
    defects: 'Other Damage/Defects',
    with_trailer: 'With transport trailer',
    without_trailer: 'Without transport trailer',
    accessories_description: 'Equipment and Accessories',
    admin_comment: 'Comments',
    not_financed_vehicle: 'Not Financed',
    financed_vehicle_1: 'Financed',
    abs: 'ABS',
    vin: 'VIN Number',
    without_abs: 'No ABS',
    not_imported: 'Not Imported',
    with_service_booklet: 'Service History',
    motorbike_service_booklet_options: {
      not_run: 'No Service History',
      existing: 'Service History Available',
      run: 'Complete Service History',
      digitally_run: 'Digital Service History'
    },
    not_categorized_attributes_section_title: 'Vehicle Details',
    general_condition_section_title: 'Vehicle Condition',
    score: 'Score',
    general_condition: 'General Condition',
    consumables_condition: 'Wear Parts',
    tires: 'Tires',
    tires_age: 'Tire age',
    tires_condition: 'Tire tread depth',
    motorbike_general_condition_options: {
      as_new: 'As New',
      well_maintained: 'Very Good',
      average: 'Minor Wear',
      bad: 'Accident Damaged',
      care: 'Needs Care',
      tatty: 'Poor'
    },
    motorbike_consumables_condition_options: {
      as_new: 'As New',
      well_maintained: 'Good',
      average: 'Fair',
      tatty: 'Poor',
      not_known: 'Unknown',
      bad: 'Bad',
      care: 'Adequate'
    },
    motorbike_tires_options: {
      '25%': '25%',
      '50%': '50%',
      '75%': '75%',
      bad: 'Worn or older than 6 years',
      very_well: 'Like New',
      not_known: 'Unknown'
    },
    motorbike_tires_age_options: {
      under_six_years_old: 'Under 6 years old',
      over_six_years_old: '6 years old or older',
      not_known: 'I’m not sure'
    },
    motorbike_tires_condition_options: {
      _0_: 'Worn out',
      _25_: '25%',
      _50_: '50%',
      _75_: '75%',
      _100_: 'New',
      not_known: 'I’m not sure'
    },
    services: 'Inspections',
    motorbike_last_inspection: 'Last Service',
    motorbike_next_hu: 'Next Inspection',
    photos_screen_title: 'Gallery',
    camper_number_of_seats: 'Number of Seats',
    camper_commercial_use: 'Commercial Use',
    camper_without_commercial_use: 'No Commercial Use',
    bool_options: {
      true: 'Yes',
      false: 'No'
    },
    camper_type: 'Vehicle Type',
    camper_type_options: {
      caravan: 'Caravan',
      van: 'Van/CUV',
      semi_integrated: 'Semi-Integrated',
      fully_integrated: 'Fully Integrated',
      alcove: 'Alcove',
      luxury: 'Luxury Liner',
      car: 'Car'
    },
    camper_next_hu: 'Next Inspection',
    camper_last_inspection: 'Last Inspection',
    agricultural_production_year: 'Year of Manufacture',
    agricultural_meter: 'Mileage',
    agricultural_general_condition_options: {
      as_new: 'New',
      well_maintained: 'Lightly Used',
      average: 'Used',
      bad: 'Needs Repair',
      care: '',
      tatty: ''
    }
  },
  browse: 'Vehicles',
  all_vehicles: 'All Vehicles',
  liked_vehicles: 'Favorites',
  first_offer: 'No Bids',
  highest_offer: 'Outbid',
  highest_offer_short: 'Highest Bid',
  first_offer_short: 'No Bids',
  buy_now: 'Buy Now',
  no_offers: 'Currently there are no vehicles \n that match your criteria.',
  offer_to_low: 'Minimum Bid € ',
  date: 'First Reg',
  agricultural_production_year: 'Year',
  mileage: 'Mileage',
  country: 'Location',
  bets_count: 'Number of Bids',
  your_offer: 'Your Bid',
  buy_now_expanded_view: 'Buy Now',
  minimal_offering: 'Asking Price',
  new_offer_button: 'Place Bid',
  buy_now_button: 'Buy Now',
  bets_table_title: 'Your Bids',
  archive_tab_title: 'Purchase Archive',
  sold_tab_title: 'Sales Archive',
  company_data_title: 'Company Data',
  company_data: 'Company Data',
  in_realization_table: 'In Progress',
  messages: 'Messages',
  auctions: 'My Bids',
  in_realization: 'In Progress',
  invoices: 'Invoices',
  archive: 'Archive',
  my_auctions: 'Purchase',
  accepted_offer: 'Offer Accepted',
  archived_date: 'Archived',
  sold: 'Sold',
  app_should_be_updated: 'A new app version is available',
  update: 'Update',
  Motorbike_offers: 'Motorcycles',
  JetSki_offers: 'Jet Skis',
  AgriculturalMachine_offers: 'Agricultural Machinery',
  Camper_offers: 'Motorhomes & Caravans',
  message_placeholder: 'Write message',
  application_version: 'App Version',
  remove_account: 'Delete Account',
  log_out: 'Log Out',
  profile: 'PROFILE',
  profile_settings: 'Master Data',
  auth_settings: 'APP SETTINGS',
  update_application: 'Update',
  check_updates: 'Check Availability',
  remove_account_confirmation: 'Are you sure you want to delete your account?',
  set_password: 'Set Password',
  set_language: 'Language',
  integrations: 'Integrations',
  integrations_screen: {
    title: 'Integrations',
    login: 'Login',
    password: 'Password',
    add: 'Add integration',
    empty: 'No integration is connected yet.',
    cancel: 'Cancel',
    connect: 'Connect',
    connected: 'Account connected',
    seller_id: 'Seller ID',
    sync: 'Sync vehicles',
    sync_started: 'Sync started. Vehicles will show up on the vehicle list.',
    connect_success: 'mobile.de account connected',
    connect_error: 'Could not connect the account',
    load_error: 'Could not load integrations',
    sync_error: 'Could not start the sync',
    disconnect: 'Remove integration',
    disconnect_title: 'Remove this integration?',
    disconnect_message:
      'The account will be disconnected. Listings stay on mobile.de. You can add the integration again afterwards, for example with a new password.',
    disconnect_confirm: 'Remove',
    disconnect_success: 'Integration removed',
    disconnect_error: 'Could not remove the integration'
  },
  profile_settings_screen_header: 'Settings',
  save_password: 'Save',
  update_password_form: {
    current_password: 'Current Password',
    new_password: 'New Password',
    confirm_new_password: 'Confirm Password',
    password_not_match: 'Passwords do not match',
    password_do_not_meet_requirements:
      'Password should be at least 8 characters and contain uppercase and lowercase letters and a special character like "!@#$%^&*"',
    current_password_invalid: 'Current password is incorrect',
    password_to_short: 'Password is too short (minimum 8 characters)',
    unknown_error: 'Something went wrong. Please try again'
  },
  sign_in_screen: {
    do_not_have_account: 'No account yet?',
    registration: 'Register Now',
    registration_url: 'https://estigroup.de',
    title: 'Sign In',
    forgot_password: 'Forgot Password?',
    sign_in: 'Sign In',
    forgot_password_title: 'Reset Password',
    forgot_password_description: "Enter your email and we'll send you a link to reset your password.",
    reset_password: 'Reset Password',
    remind_password: 'Send',
    reset_instructions_sent: 'Password reset instructions have been sent to your email',
    password_invalid: 'Incorrect password',
    email_invalid: 'Invalid email',
    repeat_password: 'Repeat Password',
    password: 'Password',
    password_requirement_uppercase: 'Min. 1 uppercase letter',
    password_requirement_number: 'Min. 1 number',
    password_requirement_special_char: 'Min. 1 special character (!#$%@*^&)',
    password_requirement_min_length: 'Min. 8 characters'
  },
  profile_settings_form: {
    name: 'Name',
    last_name: 'Last Name',
    nickname: 'First Name',
    phone: 'Phone',
    email: 'Email',
    company_name: 'Company Name',
    ftin: 'VAT ID',
    street: 'Street',
    zip_code: 'ZIP Code',
    place: 'City',
    iban: 'IBAN',
    bic: 'BIC',
    save: 'Save'
  },
  filter_modal: {
    localization: 'Location',
    vehicle: 'Vehicle',
    hash_id: 'ID Number',
    damaged_label: 'Vehicle Condition',
    damaged: 'Damaged',
    not_damaged: 'Not Damaged',
    all: 'All',
    year_form: 'Year from',
    year_to: 'Year to',
    milage_from: 'Miles from',
    milage_to: 'Miles to',
    zpi_code_input: 'ZIP Code',
    area: 'Radius',
    country: 'Country',
    filter_offers: 'Refine Search',
    filter_button: 'Hide',
    motorbikes: 'Motorcycles',
    agricultural_machines: 'Agricultural Machinery',
    campers: 'Motorhomes & Caravans',
    vehicle_type: 'Vehicle Type',
    motorbike_model: 'Model',
    motorbike_brand: 'Brand',
    brand_options: [
      {
        optionLabel: 'Access Motor',
        optionVal: 33
      },
      {
        optionLabel: 'Aprilia',
        optionVal: 3
      },
      {
        optionLabel: 'BMW',
        optionVal: 2
      },
      {
        optionLabel: 'Benelli',
        optionVal: 18
      },
      {
        optionLabel: 'Beta',
        optionVal: 23
      },
      {
        optionLabel: 'Bimota',
        optionVal: 20
      },
      {
        optionLabel: 'Buell',
        optionVal: 4
      },
      {
        optionLabel: 'CFMoto',
        optionVal: 28
      },
      {
        optionLabel: 'Can Am',
        optionVal: 31
      },
      {
        optionLabel: 'Daelim',
        optionVal: 24
      },
      {
        optionLabel: 'Ducati',
        optionVal: 5
      },
      {
        optionLabel: 'Harley-Davidson',
        optionVal: 6
      },
      {
        optionLabel: 'Honda',
        optionVal: 1
      },
      {
        optionLabel: 'Husaberg',
        optionVal: 26
      },
      {
        optionLabel: 'Husqvarna',
        optionVal: 7
      },
      {
        optionLabel: 'Hyosung',
        optionVal: 25
      },
      {
        optionLabel: 'Indian',
        optionVal: 8
      },
      {
        optionLabel: 'KTM',
        optionVal: 10
      },
      {
        optionLabel: 'Kawasaki',
        optionVal: 9
      },
      {
        optionLabel: 'Kymco',
        optionVal: 22
      },
      {
        optionLabel: 'MV Agusta',
        optionVal: 12
      },
      {
        optionLabel: 'Moto-Guzzi',
        optionVal: 11
      },
      {
        optionLabel: 'Peugeot',
        optionVal: 27
      },
      {
        optionLabel: 'Piaggio',
        optionVal: 19
      },
      {
        optionLabel: 'Polaris',
        optionVal: 30
      },
      {
        optionLabel: 'Royal Enfield',
        optionVal: 32
      },
      {
        optionLabel: 'Suzuki',
        optionVal: 13
      },
      {
        optionLabel: 'TGB',
        optionVal: 29
      },
      {
        optionLabel: 'Triumph',
        optionVal: 14
      },
      {
        optionLabel: 'Vespa',
        optionVal: 21
      },
      {
        optionLabel: 'Victory',
        optionVal: 15
      },
      {
        optionLabel: 'Yamaha',
        optionVal: 16
      }
    ]
  },
  my_vehicles: {
    title: 'My vehicles',
    in_stock: 'In stock',
    sold: 'Sold',
    add_vehicle: 'Add vehicle',
    edit_vehicle: 'Edit vehicle',
    vehicle: 'Vehicle',
    actions: 'Actions',
    details: 'Vehicle details',
    mark_as_sold: 'Mark vehicle as sold',
    mark_as_in_stock: 'Restore vehicle to stock',
    toast_marked_sold: 'Marked {{name}} as sold',
    toast_restored_stock: 'Restored {{name}} to stock',
    toast_vehicle_fallback: 'vehicle',
    toast_vehicle_added: 'Vehicle added',
    toast_issue_invoice: 'Issue invoice',
    documents: 'Documents',
    no_documents: 'No documents for this vehicle',
    photos: 'Photos',
    photos_empty: 'This vehicle has no photos yet.',
    add_photo: 'Add photo',
    delete_photo_title: 'Delete this photo?',
    delete_photo_message: 'The photo will be removed from this vehicle gallery.',
    photo_added: 'Photo added',
    photo_deleted: 'Photo deleted',
    photo_type_error: 'Only JPEG and PNG files are allowed.',
    photo_upload_error: 'Could not save the photo',
    edit: 'Edit',
    delete: 'Delete',
    view_offer: 'View offer',
    empty_title: 'Add your first vehicle',
    empty_subtitle: 'You will issue documents for your customers for every motorcycle.',
    sold_empty_title: 'Sold a vehicle? Mark it as sold.',
    sold_empty_subtitle: 'We will move it here with all documentation so your in-stock list stays organized.',
    vehicle_data: 'Vehicle data',
    source_purchased: 'Choose from purchased',
    source_own: 'Add your own vehicle',
    brand: 'Brand',
    model: 'Model',
    year: 'Year',
    mileage: 'Mileage',
    vin: 'VIN',
    choose: 'Choose',
    mileage_placeholder: 'e.g.  2500',
    vin_placeholder: 'e.g. JYARM22E0LA001234',
    vin_tooltip: 'Vehicle identification number (17 characters).',
    discard: 'Discard',
    save: 'Save',
    add: 'Add',
    km: 'km',
    ccm: 'cm³',
    kw: 'kW',
    field_integer: 'Enter a whole number',
    search_purchased: 'Search motorbikes...',
    choose_vehicle: 'Choose vehicle',
    loading_offers: 'Loading...',
    no_purchased: 'No motorbikes found',
    field_required: 'Fill in this field',
    promotion: 'Promotions',
    promotion_empty_title: 'No promotions',
    promotion_empty_subtitle:
      'When the listing is on mobile.de or another portal, for example Otomoto, it will appear here.',
    promotion_mobile: 'mobile.de',
    promotion_otomoto: 'Otomoto',
    promotion_listed: 'Listing is live',
    promotion_paused: 'Paused',
    promotion_pause: 'Pause',
    promotion_resume: 'Resume',
    promotion_delete: 'Delete',
    promotion_public_link: 'View listing',
    add_promotion: 'Add promotion',
    promotion_photos: 'Listing photos',
    promotion_photos_pick: 'Choose photos',
    promotion_photos_none: 'The listing will be created without photos.',
    promotion_photos_empty: 'This vehicle has no photos. Add them on the vehicle page.',
    promotion_photos_hint: 'Choose photos from this vehicle gallery.',
    promotion_photos_limit: 'You can choose at most {{count}} photos.',
    promotion_photos_confirm: 'Save selection',
    promotion_photo_cover: 'Main',
    promotion_photo_make_cover: 'Set as main',
    edit_promotion: 'Edit promotion',
    promotion_form_title: 'Promotion on mobile.de',
    promotion_price: 'Price',
    promotion_price_placeholder: 'e.g. 12500',
    promotion_category: 'Category',
    promotion_description: 'Description',
    promotion_description_placeholder: 'Listing description',
    promotion_description_bold: 'Bold',
    promotion_description_list: 'List',
    promotion_description_rule: 'Line',
    promotion_description_undo: 'Undo',
    promotion_description_redo: 'Redo',
    promotion_highlight: 'Highlight',
    promotion_highlight_placeholder: 'e.g. ABS',
    promotion_section_vehicle: 'Vehicle',
    promotion_section_equipment: 'Equipment',
    promotion_section_service: 'Service',
    promotion_power: 'Power',
    promotion_capacity: 'Capacity',
    promotion_drive_type: 'Drive',
    promotion_gear_box: 'Gearbox',
    promotion_color: 'Color',
    promotion_metallic: 'Metallic paint',
    promotion_vat: 'VAT',
    promotion_damage: 'Unrepaired damage',
    promotion_abs: 'ABS',
    promotion_heated_grips: 'Heated grips',
    promotion_box: 'Top case',
    promotion_windshield: 'Windshield',
    promotion_kickstarter: 'Kickstarter',
    promotion_owners: 'Previous owners',
    promotion_last_inspection: 'Last inspection',
    promotion_new_inspection: 'New inspection',
    promotion_service_history: 'Full service history',
    promotion_yes: 'Yes',
    promotion_no: 'No',
    promotion_month_placeholder: 'YYYY-MM',
    promotion_months: [
      'January',
      'February',
      'March',
      'April',
      'May',
      'June',
      'July',
      'August',
      'September',
      'October',
      'November',
      'December'
    ],
    promotion_vat_23: '23%',
    promotion_vat_19: '19%',
    promotion_vat_none: 'VAT not deductible',
    promotion_gear_manual: 'Manual',
    promotion_gear_automatic: 'Automatic',
    promotion_drive_chain: 'Chain',
    promotion_drive_belt: 'Belt',
    promotion_drive_shaft: 'Shaft',
    promotion_colors: {
      BLACK: 'Black',
      GREY: 'Grey',
      BEIGE: 'Beige',
      BROWN: 'Brown',
      RED: 'Red',
      GREEN: 'Green',
      BLUE: 'Blue',
      PURPLE: 'Purple',
      GOLD: 'Gold',
      WHITE: 'White',
      ORANGE: 'Orange',
      SILVER: 'Silver',
      YELLOW: 'Yellow'
    },
    promotion_create_error: 'The mobile.de promotion could not be added.',
    promotion_update_error: 'The mobile.de promotion could not be saved.',
    toast_promotion_added: 'Promotion on mobile.de was added',
    toast_promotion_updated: 'Promotion on mobile.de was updated',
    toast_promotion_paused: 'The listing was paused on mobile.de',
    toast_promotion_deleted: 'The listing was removed from mobile.de',
    toast_promotion_resumed: 'The listing was published on mobile.de again',
    promotion_categories: {
      ChopperAndCruiser: 'Chopper / cruiser',
      CombinationAndSidecar: 'Combination / sidecar',
      DirtBike: 'Dirt bike',
      EnduroAndTouringEnduro: 'Enduro',
      LightweightMotorcycleAndMotorbike: 'Lightweight motorcycle',
      MotorAssistedBicycleAndSmallMoped: 'Moped',
      Motorcycle: 'Motorcycle',
      NakedBike: 'Naked bike',
      Pocketbike: 'Pocket bike',
      Racing: 'Racing',
      RallyAndCross: 'Rally / cross',
      Scooter: 'Scooter',
      SportTouringMotorcycle: 'Sport touring',
      SportsAndSuperSportsBike: 'Sports bike',
      Streetfighter: 'Streetfighter',
      SuperMoto: 'Supermoto',
      Tourer: 'Tourer',
      Trike: 'Trike',
      OtherMotorbike: 'Other',
      Quad: 'Quad'
    },
    add_document: 'Add document',
    document_invoice: 'Invoice',
    document_sell_contract: 'Sales contract',
    document_import: 'Import document',
    document_open: 'Open',
    document_download: 'Download',
    documents_empty_title: 'Add the first document',
    documents_empty_subtitle: 'You can issue an invoice, contract and import document for this motorcycle here.'
  },
  clients: {
    title: 'Clients',
    add_client: 'Add client',
    name: 'Client name',
    email: 'E-mail',
    phone: 'Phone number',
    country: 'Country',
    actions: 'Actions',
    details: 'Client details',
    edit: 'Edit',
    delete: 'Delete',
    copy_email: 'Copy e-mail',
    email_copied: 'Copied',
    empty_title: 'Add your first client',
    empty_subtitle: 'Clients will show up here after you add them.',
    edit_client: 'Edit client',
    client_data: 'Client data',
    company: 'Company',
    personal: 'Private person',
    company_name: 'Company name',
    document_number: 'Document number',
    vat_number: 'VAT number',
    id_number: 'ID number',
    place: 'City',
    zip_code: 'Postal code',
    street: 'Street',
    house_number: 'House number',
    first_name: 'First name',
    last_name: 'Last name',
    company_name_placeholder: 'e.g. AutoMoto Ltd.',
    document_number_placeholder: 'e.g. 12345678',
    vat_number_placeholder: 'e.g. GB123456789',
    id_number_placeholder: 'e.g. 533380006',
    place_placeholder: 'e.g. London',
    zip_code_placeholder: 'e.g. SW1A 1AA',
    street_placeholder: 'e.g. Baker Street',
    house_number_placeholder: 'e.g. 221B',
    first_name_placeholder: 'e.g. James',
    last_name_placeholder: 'e.g. Smith',
    email_placeholder: 'e.g. j.smith@automoto.co.uk',
    phone_placeholder: 'e.g. +44 20 7946 0958',
    tax_number: 'Tax number',
    full_name: 'Full name',
    city: 'City',
    documents: 'Document list',
    documents_empty_subtitle: 'You can issue an invoice, a sales contract and an import document for this client here.',
    search: 'Search',
    document_invoice: 'Invoice',
    document_contract: 'Contract',
    document_import: 'Import document',
    countries: {
      poland: 'Poland',
      germany: 'Germany'
    }
  },
  sell_contract: {
    contract_data: 'Contract details',
    vehicle: 'Vehicle',
    client: 'Client',
    contract_language: 'Contract language',
    select: 'Select',
    select_client: 'Select client',
    select_vehicle: 'Select vehicle',
    search_clients: 'Search clients...',
    no_clients: 'No clients found',
    currency: 'Currency',
    vat_rate: 'VAT rate',
    price: 'Price',
    gross: 'Gross',
    net: 'Net',
    net_price: 'Net price',
    vat: 'VAT ({{rate}}%)',
    gross_price: 'Gross price',
    additional_services: 'Additional services',
    additional_service_name: 'Name',
    additional_service_amount: 'Amount',
    additional_service_add: 'Add service',
    additional_service_remove: 'Remove',
    additional_service_total: 'Total price',
    down_payment: 'Down payment',
    down_payment_amount: 'Down payment amount',
    payment_method: 'Payment method',
    payment_type: 'Payment type',
    bank_transfer: 'Bank transfer',
    instant_transfer: 'Instant transfer',
    cash: 'Cash',
    financing: 'Financing',
    date: 'Date',
    on_contract: 'Contract',
    down_payment_date: 'Down payment date',
    delivery: 'Delivery',
    date_format: 'Date format',
    exact_date: 'Exact date',
    time_span: 'Time span',
    delivery_date: 'Delivery date',
    delivery_period: 'Delivery period',
    commitment: 'Commitment',
    binding: 'Binding',
    non_binding: 'Non-binding',
    delivery_method: 'Delivery method',
    delivery_place: 'Place or delivery address',
    additional_service_delivery_cost: 'This is the handover cost',
    payment_due: 'Payment due',
    payment_due_handover: 'On handover against invoice',
    payment_due_custom: 'Other date',
    payment_due_text: 'Agreed date',
    registration_state: 'Registration status at handover',
    registration_deregistered: 'Deregistered',
    registration_registered: 'Registered',
    registration_by: 'Registration is done by',
    registration_seller: 'Seller',
    registration_buyer: 'Buyer',
    client_delivery: 'Client delivery',
    dealer_delivery: 'Dealer delivery',
    damages: 'Damages and deviations',
    remarks: 'Notes / other',
    remarks_hint: 'Here you can enter known defects, damage, problems and other notes about the vehicle.',
    previous_owner_damages: 'Previous owner damages and deviations',
    yes: 'Yes',
    no: 'No',
    not_specified: 'Not specified',
    exclude_updates: 'Should the obligation to update digital products and goods with digital elements be excluded?',
    shorten_warranty: 'Shorten warranty to one year',
    language_de: 'German',
    language_pl: 'Polish',
    vat_23: '23% VAT',
    vat_10: '10% VAT',
    vat_5: '5% VAT',
    vat_marginal: 'Marginal taxation',
    vat_small_business: 'Small business',
    month_1: '1 month',
    month_2: '2 months',
    month_3: '3 months',
    month_4: '4 months',
    month_5: '5 months',
    description: 'Description',
    objective_deviations: 'Are there deviations from the objective requirements?',
    objective_deviation_1: 'Deviation description',
    objective_deviation_placeholder: 'Part, condition and consequences of use',
    further_agreements: 'Further agreements on condition',
    further_agreements_placeholder: 'Leave empty if nothing was agreed',
    eur: 'EUR (€)',
    pln: 'PLN (zł)',
    date_placeholder: 'DD.MM.YYYY',
    field_required: 'Fill in this field',
    vin_value: 'VIN: {{vin}}',
    mileage_value: 'Mileage {{mileage}}',
    year_value: 'Year: {{year}}',
    email_value: 'E-mail: {{email}}',
    phone_value: 'Phone: {{phone}}',
    address_value: 'Address: {{address}}',
    mileage_statement: 'Mileage statement',
    mileage_statement_known: 'Mileage is known',
    mileage_statement_unknown: 'Mileage is unknown',
    mileage_statement_custom: 'Custom mileage terms',
    mileage_statement_text: 'Mileage agreement text',
    previous_owners_basis: 'Basis of the previous-owners statement',
    previous_owners_basis_placeholder: 'Documents or specific information',
    key_count: 'Number of keys',
    other_equipment: 'Other equipment',
    missing_items: 'Missing documents or parts'
  },
  unsaved_changes: {
    title: 'You have unsaved changes',
    body: 'If you leave now, the data you entered will be lost.',
    leave: 'Leave without saving',
    stay: 'Back to editing'
  },
  mobile_redirect: {
    title: 'Download our mobile app',
    subtitle: 'to browse current listings and explore the platform in demo mode.',
    step1: 'Download the Estimoto app to your phone (Android/iOS).',
    step2: 'Log in using the',
    step2_highlight: 'same email address',
    step3: 'and the password sent to your inbox.',
    step4: "You'll get access to the demo version and real, up-to-date motorcycle offers.",
    open_app: 'Open mobile app',
    google_play: 'Google Play',
    app_store: 'App Store'
  },
  invoice_form: {
    sales_invoices: 'Sales invoices',
    add_invoice: 'Add invoice',
    edit_invoice: 'Edit invoice',
    invoice_data: 'Client data',
    nip: 'VAT no.: {{number}}',
    invoice_number: 'Invoice number',
    invoice_number_placeholder: 'e.g. INV/2026/001',
    invoice_language: 'Invoice language',
    language_en: 'English',
    invoice_date: 'Invoice date',
    payment_due: 'Payment due',
    additional_info: 'Additional information'
  }
}
